<script setup lang="ts">
import DepartmentPanel from "@/components/people/DepartmentPanel.vue"
import { onMounted, reactive } from "vue"

const state = reactive<{
  departmentData: Array<any>
  peopleData: Array<any>
}>({
  departmentData: [],
  peopleData: [],
})

onMounted(async () => {
  const departmentData = await fetch("/api/taxonomy/departments/parents").then((res) => res.json())
  state.departmentData = departmentData
})
</script>

<template>
  <div class="people">
    <DepartmentPanel
      v-for="(item, index) in state.departmentData"
      :key="index"
      :department="item"
      :open="true"
    ></DepartmentPanel>
  </div>
</template>
